import FinancialTools from './FinancialTools';
import Formatter from './Formatter';
import moment from 'moment';
export const LOAN_IN_REPAYMENT_STATUSES = ['RP', 'FB', 'ID', 'IG', 'IM'];
export const formsRequiringRecertification = [0, 3];

export const countUpcomingDates = account => {
  return !account.forms
    ? 0
    : account.forms.filter(
        form =>
          !form.archived &&
          form.live &&
          moment(form.live, 'X')
            .add(275, 'days')
            .format('X') < moment().format('X') &&
          formsRequiringRecertification.includes(parseInt(form.form.toString()))
      ).length;
};
export const getImportantDates = account => {
  const result = [];
  if (!account.forms) return result;
  account.forms
    .filter(form => !form.archived && form.completed)
    .forEach(form => {
      let formInfo = {
        id: form.id,
        form: form.form,
        name: Formatter.getGovernmentFormName(form.form, form.recertification),
        employer: form.employer,
        date: form.requested
          ? moment(
              form.requested.toString().length > 11
                ? Math.floor(form.requested / 1000)
                : form.requested,
              'X'
            ).format('MM/DD/YYYY')
          : form.date
          ? moment(form.date, 'X').format('MM/DD/YYYY')
          : '',
        event: 'completed',
        followupDate: '',
        actionable: false,
        status: form.status,
        date_approved_or_rejected: form.date_approved_or_rejected
      };
      result.push({ ...formInfo });
      if (form.live) {
        formInfo.date = moment(form.date_submited, 'X').format('MM/DD/YYYY');
        formInfo.event = 'submited';
        if (
          formsRequiringRecertification.includes(parseInt(form.form.toString()))
        ) {
          formInfo.followupDate = moment(form.date_submited, 'X')
            .add(1, 'year')
            .format('MM/DD/YYYY');
          formInfo.actionable = true;
          formInfo.approvedDate = formInfo.status === 'approved' && formInfo.date_approved_or_rejected;
          formInfo.rejectedDate = formInfo.status === 'rejected' && formInfo.date_approved_or_rejected;
        }
        result.push({ ...formInfo });
      }
    });
  // console.log(result);
  return result;
};

export const canBeSigned = form => {
  switch (parseInt(form)) {
    case 0:
      return true;
    case 1:
      return true;
    case 2:
      return true;
    case 3:
      return true;
    case 4:
      return false;
    case 5:
      return false;
    case 6:
      return true;
    case 7:
      return false;
    case 8:
      return false;
    case 9:
      return false;
    case 10:
      return false;
    case 11:
      return true;
    case 12:
      return true;
    case 13:
      return true;
    case 14:
      return true;
    case 15:
      return true;
    case 16:
      return true;
    case 17:
      return true;
    case 22:
    case 23:
    case 18:
      return true;
    case 19:
    case 20:
    case 21:
      return false;
    default:
      return false;
  }
};
export const canBeDownloaded = form => {
  switch (parseInt(form)) {
    case 0:
      return true;
    case 1:
      return true;
    case 2:
      return true;
    case 3:
      return true;
    case 4:
      return true;
    case 5:
      return false;
    case 6:
      return true;
    case 7:
      return false;
    case 8:
      return false;
    case 9:
      return false;
    case 10:
      return false;
    case 11:
      return true;
    case 12:
      return true;
    case 13:
      return true;
    case 14:
      return true;
    case 15:
      return true;
    case 16:
      return true;
    case 17:
      return true;
    case 18:
      return true;
    case 19:
      return false;
    case 20:
      return false;
    case 21:
      return false;
    case 23:
    case 22:
      return true;
    default:
      return false;
  }
};
export const canBeSubmitted = form => {
  switch (parseInt(form)) {
    case 5:
    case 9:
    case 10:
    case 19:
    case 21:
      return false;
    default:
      return true;
  }
};
export const hasDefaultServicer = form => {
  if (form === "6306e4e527c74b5fe788f78c") {
    // PSLF authorization form
    return true;
  }
  const formWithDefaultServicers = [0, 1, 2, 3, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 22];
  if (formWithDefaultServicers.includes(parseInt(form))) {
    return true;
  }
  return false;
};
export const getCurrentAccrual = user => {
  let balance = getCurrentBalance(user);
  let rate = getWeightedInterestRate(user) / 100;
  let interest = (balance * rate) / 12;
  return Math.floor(Math.max(0, interest));
};
export const getCummulativePSLFMonths = user => {
  if (!user.msd || !user.msd.details || user.msd.details.isArtificial) {
    return 0;
  }
  else
    return (user.msd.details.student_loans || []).reduce(
      (max, loanType) =>
        Math.max(loanType.loans
          .filter((loan) => Formatter.moneyToNumber(loan.loan_outstanding_principal_balance))
          .reduce((amount, loan) => Math.max(amount, loan.loan_pslf_matched_monts), 0),
          max
        ),
      0
    );
};

export const getCurrentBalance = user => {
  if (user.loanType !== "private") {
    if (!user.msd || !user.msd.details.student_loans) return 0;
    else
      return user.msd.details.student_loans.reduce(
        (total, loan) =>
          total +
          parseFloat(
            Formatter.moneyToNumber(loan.total_outstanding_principal).toString()
          ),
        0
      );
  }
};

export const getCurrentMMP = user => {
  if (user.loanType !== "private") {
    if (!user.msd || !user.msd.details.student_loans) return 0;
    else
      return user.msd.details.student_loans.reduce((total, loan) => {
        return (
          total +
          loan.loans.reduce((amount, subLoan) => {
            let loanInfo = FinancialTools.parseLoan(subLoan);
            if (loanInfo.repayment) return amount + loanInfo.mmp;
            else return amount;
          }, 0)
        );
      }, 0);
  }
};

export const getCurrentStrategy = (loanId, user) => {
  if (user.custom_analysis) {
    if (
      user.custom_analysis.consolidation &&
      user.custom_analysis.consolidation.loans.find(loan => loan.id == loanId)
    )
      return 0;
    else return 1;
  } else
    return user.analysis.find(analysis =>
      analysis.loans.find(loan => loan.id == loanId)
    ).strategy;
};

export const isReadyToSubmit = (form, forms) => {
  let formIdentifier;
  if (form.length > 4) {
    formIdentifier = null;
  } else {
    form = formIdentifier;
  }
  switch (parseInt(formIdentifier)) {
    case 0:
      return {
        ready: forms.find(
          form =>
            (form.form == 5 || form.form == 9 || form.form == 10) &&
            form.completed &&
            form.file
        )
          ? true
          : false,
        message:
          'An Income Driven Repayment Plan request must include a proof of income, either Last Year Tax returns, last 2 pay stubs, or letter to verify income.'
      };
    case 9:
    case 5:
    case 10:
    case 19:
      return {
        ready: false,
        message:
          'This form can only be submitted combined with an Income Driven Repayment Plan request.'
      };
    default:
      return {
        ready: true,
        message: ''
      };
  }
};
const getLoanInfoFromStudentData = (loanId, studentData) => {
  if (!studentData) {
      return null;
  }
  for(let i = 0; i < studentData.student_loans.length; i++) {
      const loan = studentData.student_loans[i].loans.find((each) => each.id === loanId)
      if (loan) {
          return loan;
      }
  }
  return null;
}

const getCurrentPlan = (user) => {
  if (!user.analysis || !user.analysis.analysis) {
      return "";
  }
  let planText = "";
  const consolidated = user.analysis.analysis.find((each) => each.strategy === 0)
  const notConsolidated = user.analysis.analysis.find((each) => each.strategy === 1)
  if (consolidated && user.msd) {
      const firstConsolidatedLoanDetails = getLoanInfoFromStudentData(consolidated.loans[0].id, user.msd.details);
      if (firstConsolidatedLoanDetails) {
          planText += `Consolidated: ${firstConsolidatedLoanDetails.loan_repayment_plan_type || "STANDARD"}\n`;
      }
  }
  if (notConsolidated && user.msd) {
      const firstnotConsolidatedLoanDetails = getLoanInfoFromStudentData(notConsolidated.loans[0].id, user.msd.details);
      if (firstnotConsolidatedLoanDetails) {
          planText += `NotConsolidated: ${firstnotConsolidatedLoanDetails.loan_repayment_plan_type || "STANDARD"}`;
      }
  }
  return planText;
}

export const getCurrentRepaymentPlan = (loanId, myStudentData) => {
  let loan;
  myStudentData.student_loans.forEach(loanType => {
    if (!loan)
      loan = loanType.loans.find(existingLoan => existingLoan.id == loanId);
  });
  if (!loan) return 0;
  if (!loan.loan_repayment_plan_type) return 0;
  else if (loan.loan_repayment_plan_type.indexOf('INCOME-BASED REPAYMENT') >= 0)
    return 6;
  else if (loan.loan_repayment_plan_type.indexOf('REVISED PAY AS YOU EARN') >= 0)
    return 5;
  else if (loan.loan_repayment_plan_type.indexOf('SAVE') >= 0)
    return 5;
  else if (loan.loan_repayment_plan_type.indexOf('PAY AS YOU EARN') >= 0)
    return 4;
  else if (loan.loan_repayment_plan_type.indexOf('EXTENDED GRADUATED') >= 0)
    return 2;
  else if (loan.loan_repayment_plan_type.indexOf('EXTENDED FIXED') >= 0)
    return 3;
  else if (loan.loan_repayment_plan_type.indexOf('GRADUATED') >= 0) return 1;
  else if (loan.loan_repayment_plan_type.indexOf('INCOME-CONTINGENT REPAYMENT') >= 0)
    return 7;
  else if (loan.loan_repayment_plan_type.indexOf('EXTENDED REPAYMENT') >= 0)
    return 11;
  return 0;
};
export const getStandardizedStrategy = user => {
  let result = {
    consolidation: [],
    nonConsolidation: []
  };
  if (user.loanType === 'private') {
    return null
  } 
  else if  (!user || !user.msd || (!user.analysis && !user.custom_analysis))
    return result;
  else {
    user.analysis.analysisDetails.forEach(strategy => {
      if (strategy.strategy == 0) {
        result.consolidation.push({
          type: 'DIRECT CONSOLIDATED',
          balance: strategy.loans.reduce(
            (balance, loan) => balance + loan.balance,
            0
          ),
          mmp:
            strategy.repayment.length > 0 ? strategy.repayment[0].monthly : 0,
          forgiveness: strategy.forgiveness ? strategy.forgiveness.amount : 0,
          lastPayment: strategy.forgiveness
            ? strategy.forgiveness.repayment.length >
              Math.floor(strategy.forgiveness.periods / 12) +
                (strategy.forgiveness.periods % 12 == 0 ? 0 : 1)
              ? strategy.forgiveness.repayment[
                  Math.floor(strategy.forgiveness.periods / 12) +
                    (strategy.forgiveness.periods % 12 == 0 ? 0 : 1)
                ].year
              : strategy.forgiveness.repayment.length > 0
              ? strategy.forgiveness.repayment[
                  strategy.forgiveness.repayment.length - 1
                ].year
              : 'Unknown'
            : strategy.repayment.length > 0
            ? strategy.repayment[strategy.repayment.length - 1].year
            : 'Unknown',
          rate: FinancialTools.getWeightedInterestRate(strategy.loans),
          plan: Formatter.repaymentPlanText(strategy.plan),
          plan_code: strategy.plan,
          loans: strategy.loans.map(loan => {
            return {
              id: loan.id,
              type: loan.type.name,
              balance: loan.balance,
              mmp: loan.mmp,
              rate: loan.rate,
              servicer: Formatter.getServicerName(loan.id, user.msd.details)
            };
          })
        });
      } else {
        strategy.loans.forEach(loan => {
          result.nonConsolidation.push({
            id: loan.id,
            type: loan.type.name,
            rate: loan.rate,
            balance: loan.balance,
            servicer: Formatter.getServicerName(loan.id, user.msd.details),
            mmp: loan.mmp,
            newMMP: getWeightedMMP(
              strategy.repayment.length > 0 ? strategy.repayment[0].monthly : 0,
              loan,
              strategy.loans
            ),
            plan: Formatter.repaymentPlanText(strategy.plan),
            plan_code: strategy.plan
          });
        });
      }
    });
    return result;
  }
};

export const getWeightedMMP = (totalMMP, loan, loans) => {
  if (totalMMP <= 0) return 0;
  let totalBalance = loans.reduce((balance, loan) => balance + loan.balance, 0);
  if (totalBalance > 0) {
    let percent = (loan.balance * 100) / totalBalance / 100;
    return totalMMP * percent;
  } else return loans.length > 0 ? totalMMP / loans.length : 0;
};
export const noChangeInRecommendedPlan = user => {
  if (!user.analysis.analysisDetails) {
    return true;
  }
  for (let i = 0; i < user.analysis.analysisDetails.length; i++) {
    const theAnalysis = user.analysis.analysisDetails[i];
    const recommendedPlan = theAnalysis.plans.find(each => each.isPlanRecommended);
    if (recommendedPlan.plan !== theAnalysis.loans[0].plan) {
      return false;
    }
  }
  return true  
};
export const loanIsInRepayment = (loanId, user) => {
  let result = false;
  user.msd.details.student_loans.forEach(loanType => {
    let loan = loanType.loans.find(loan => loan.id == loanId);
    if (loan && loan.loan_status && loan.loan_status.length > 0) {
      result = LOAN_IN_REPAYMENT_STATUSES.includes(
        loan.loan_status[0].status.toUpperCase()
      );
    }
  });
  return result;
};
export const getRecertificationDate = user => {
  let date = '';
  let minDate = 99999999999;
  if (user.msd) {
    
  user.msd.details.student_loans.forEach(loanType => {
    user.msd.details.student_loans.forEach(loanType => {
      loanType.loans
        .filter(
          loan =>
            loanIsInRepayment(loan.id, user) &&
            [4, 5, 6, 7].includes(
              Formatter.repaymentPlanCode(loan.loan_repayment_plan_type)
            ) &&
            loan.loan_repayment_idr_anniversary
        )
        .forEach(loan => {
          const time = moment(
            loan.loan_repayment_idr_anniversary,
            'MM/DD/YYYY'
          ).format('X');
          if (time < minDate) {
            minDate = time;
          }
        });
    });
    });
  }

  return moment(minDate, 'X').format('MM/DD/YYYY');
};
export const getLoanCurrentPlanCode = (loanId, user) => {
  let code = -1;
  user.msd.details.student_loans.forEach(loanType => {
    if (code === -1) {
      let loan = loanType.loans.find(loan => loan.id == loanId);
      if (loan) {
        code = Formatter.repaymentPlanCode(loan.loan_repayment_plan_type);
      }
    }
  });
  return code;
};

export const getWeightedInterestRate = user => {
  if (!user || !user.msd.details) return 0;
  else {
    let loans = [];
    user.msd.details.student_loans.forEach(loan => {
      loan.loans.forEach(subLoan => {
        if (
          Formatter.moneyToNumber(subLoan.loan_outstanding_principal_balance) >
          0
        )
          loans.push(subLoan);
      });
    });
    return FinancialTools.getWeightedInterestRate(loans);
  }
};

export const getLoanType = loanTypeName => {
  let result = {
    name: loanTypeName,
    id: '',
    direct: false,
    subsidized: false,
    unsibsidized: false,
    consolidated: false,
    stafford: false,
    perkins: false,
    ffel: false,
    plus: false,
    parent: false,
    private: false,
    sula: false,
    graduate: false,
    professional: false,
    supplemental: false,
    student: false,
    nursing: false,
    health: false,
    national: false,
    defense: false,
    auxiliary: false,
    education: false,
    disadvantaged: false
  };
  let loanId = '';
  let loanInfo = loanTypeName.toUpperCase().split(' ');
  loanInfo
    .map(info => info.replace(new RegExp('[^A-Za-z]', 'g'), ''))
    .forEach(info => {
      loanId += info.charAt(0);
      switch (info) {
        case 'DIRECT':
          result.direct = true;
          break;
        case 'SUBSIDIZED':
          result.subsidized = true;
          break;
        case 'UNSUBSIDIZED':
          result.unsibsidized = true;
          break;
        case 'UNSUBSIDIZED':
          result.unsibsidized = true;
          break;
        case 'CONSOLIDATED':
          result.consolidated = true;
          break;
        case 'STAFFORD':
          result.stafford = true;
          break;
        case 'PERKINS':
          result.perkins = true;
          break;
        case 'FFEL':
          result.ffel = true;
          break;
        case 'PLUS':
          result.plus = true;
          break;
        case 'PARENT':
          result.parent = true;
          break;
        case 'PRIVATE':
          result.private = true;
          break;
        case 'GRADUATE':
          result.graduate = true;
          break;
        case 'PROFESSIONAL':
          result.professional = true;
          break;
        case 'STUDENT':
          result.student = true;
          break;
        case 'SUPPLEMENTAL':
          result.supplemental = true;
          break;
        case 'NATIONAL':
          result.national = true;
          break;
        case 'DEFENSE':
          result.defense = true;
          break;
        case 'EDUCATION':
          result.education = true;
          break;
        case 'AUXILIARY':
          result.auxiliary = true;
          break;
        case 'DISADVANTAGED':
          result.disadvantaged = true;
          break;
        case 'NURSE':
        case 'NURSING':
          result.nursing = true;
          break;
        case 'HEALTH':
        case 'HEALTHCARE':
          result.health = true;
          break;
      }
    });
  result.sula = loanTypeName.toUpperCase().indexOf('SULA ELIGIBLE') >= 0;
  result.id = loanId;
  if (result.perkins || result.disadvantaged) result.subsidized = true;
  return result;
};
export const getRecommendedPlanName = user => {
  const standardStrategy = getStandardizedStrategy(user);

  if (
    standardStrategy.consolidation &&
    standardStrategy.consolidation.length > 0
  ) {
    return standardStrategy.consolidation[0].plan;
  } else if (
    standardStrategy.nonConsolidation &&
    standardStrategy.nonConsolidation.length > 0
  )
    return standardStrategy.nonConsolidation[0].plan;
  else {
    return 'CURRENT PLAN';
  }
};
export const parseMyStudentDataLoan = (loan, typeName) => {
  return {
    type: getLoanType(typeName),
    amount: Formatter.moneyToNumber(loan.loan_amount),
    balance: loan.loan_outstanding_principal_balance,
    interest: loan.loan_outstanding_interest_balance,
    id: loan.id,
    startDate: loan.loan_repayment_plan_begin_date,
    status:
      loan.loan_status.length > 0
        ? Formatter.codeStatus(loan.loan_status[0].status)
        : 8,
    pslf: Formatter.moneyToNumber(loan.loan_pslf_matched_monts),
    mmp: Formatter.moneyToNumber(loan.loan_repayment_plan_scheduled_amount),
    rate: Formatter.moneyToNumber(loan.loan_interest),
    servicer: loan.servicer
  };
};
export const hasLoansInDefaultOrBankrupcy = user => {
  if (user.loanType !== "private" && user.msd) {
    return user.msd.details.student_loans.find(loanType =>
      loanType.loans.find(
        loan =>
          loan.loan_status &&
          loan.loan_status.length > 0 &&
          ['BC', 'BK', 'DB', 'DC', 'DF', 'DK', 'DL', 'DO', 'DU', 'DZ'].includes(
            loan.loan_status[0].status.toUpperCase()
          )
      )
    )
      ? true
      : false;
  }
  return false
};
export const getUncertifiedMonths = user => {
  return Math.max(user.employment.payments - getCummulativePSLFMonths(user), 0);
};

const getRecommendPlanForAnAnalysis = analysis => {
  return analysis.plans.find(eachPlan => eachPlan.isPlanRecommended);
}

export const strategyRecommendsSameIDR = ({ analysis }) => {
  for (let i = 0; i < analysis.analysisDetails.length; i++) {
    const theAnalysis = analysis.analysisDetails[i];
    if (theAnalysis.strategy === 1) {
      const recommendedPlan = getRecommendPlanForAnAnalysis(theAnalysis);
      const loan = theAnalysis.loans[0].plan;
      if (loan.plan === (recommendedPlan && recommendedPlan.plan)) {
        return true;
      }
    }
  }
  return false;
};
export const findFormMostRecentDate = (user, form) => {
  return user.forms
    .filter(f => f.form == form && f.live)
    .reduce((mostRecentDate, currentForm) => {
      if (
        !mostRecentDate ||
        (currentForm.date_submited) >
          mostRecentDate
      ) {
        mostRecentDate = currentForm.date_submited;
      }
    }, 0);
};

export const hasRecertificationPending = user => {
  return hasIDRRecertificationPending(user) || hasPSLFecertificationPending(user);
}

export const hasIDRRecertificationPending = user => {
  if (!user.idr_recertification) {
    return false;
  }
  const idrRecertificationDate = user.idr_recertification.date;
  if (idrRecertificationDate <= getRecertificationReminderThreshold() && user.membership > 0) {
    return idrRecertificationDate;
  }
  return false;
};

export const hasPSLFecertificationPending = user => {
  if (!user.pslf_recertifications) {
    return false;
  }
  if (user.membership == 0) {
    return false;
  }
  const recertThreshold = getRecertificationReminderThreshold();
  return user.pslf_recertifications.recertificationDate <= recertThreshold ? user.pslf_recertifications : null;
};

const getRecertificationThreshold = () => {
  return moment()
    .subtract(275, 'days')
    .format('X');
};

const getRecertificationReminderThreshold = () => {
  return moment().add(90, 'days').format('X');
};

export const canSign = form => {
  if (/^[0-9]+$/.test(form.form)) {
    return canBeSigned(form.form);
  } else {
    return form.type === 'esign';
  }
};
export const canSubmit = form => {
  if (/^[0-9]+$/.test(form.form)) {
    return canBeSigned(form.form);
  } else if (form.type === 'esign') {
    return form.type === 'esign';
  } else {
    return form.type === 'manual';
  }
};

export const getMSDIDRRecertificationDate = msd => {
  for(let i = 0; i < msd.student_loans.length; i++) {
    for(let j = 0; j < msd.student_loans[i].loans.length; j++) {
      if (msd.student_loans[i].loans[j].loan_repayment_idr_anniversary) {
        return {
          date: msd.student_loans[i].loans[j].loan_repayment_idr_anniversary,
          servicer: msd.student_loans[i].loans[j].loan_contact.id
        };
      }
    }
  }
  return null;
}

export default {
  canSubmit,
  canSign,
  getLoanType,
  getCurrentMMP,
  getCurrentBalance,
  getWeightedInterestRate,
  getWeightedMMP,
  getStandardizedStrategy,
  getCurrentStrategy,
  parseMyStudentDataLoan,
  canBeSigned,
  hasDefaultServicer,
  getCurrentAccrual,
  canBeSubmitted,
  isReadyToSubmit,
  getCummulativePSLFMonths,
  getCurrentRepaymentPlan,
  getImportantDates,
  countUpcomingDates,
  noChangeInRecommendedPlan,
  getRecertificationDate,
  getRecommendedPlanName,
  hasLoansInDefaultOrBankrupcy,
  getUncertifiedMonths,
  canBeDownloaded,
  strategyRecommendsSameIDR,
  hasIDRRecertificationPending,
  hasPSLFecertificationPending,
  hasRecertificationPending,
  getRecertificationThreshold,
  getCurrentPlan
};
